const initialState = {
  requests: [],
};

const changeAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ADMIN_CHANGE_REQUESTS":
      return {
        ...state,
        requests: action.payload,
      };
    case "ACCEPT_REQUEST":
      let id = action.payload;
      let data = state.requests;
      let update = data.map((item) =>
        item.id == id ? { ...item, status: "fhp admin pending" } : item
      );
      return {
        ...state,
        requests: update,
      };
    case "REJECT_REQUEST":
      let uid = action.payload;
      let updatedRequests = state.requests.filter((item) => item.id !== uid);
      return {
        ...state,
        requests: updatedRequests,
      };
    default:
      return {
        ...state,
      };
  }
};

export default changeAdminReducer;
